exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._65oJ2{display:block;height:185px;-webkit-backface-visibility:hidden;backface-visibility:hidden;position:relative;vertical-align:bottom;overflow:hidden;background-color:#bbb;text-align:center;margin-top:15px}._1_GqT{position:absolute;right:0;left:0;bottom:0;top:0}._3pTV7{height:100%;width:auto;max-width:100%}.c9WsR{margin-bottom:12px}", ""]);

// exports
exports.locals = {
	"listPhotoCover": "_65oJ2",
	"listPhotoMedia": "_1_GqT",
	"imgResponsive": "_3pTV7",
	"space2": "c9WsR"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/DocumentList/DocumentList.css
// module id = 2528
// module chunks = 15